var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { styled } from '@mui/material';
import { Container, ContainerDisplays, ContainerFlexAlignItems, ContainerFlexDirections, ContainerFlexGaps, ContainerFlexJustifyContents, ContainerPaddings } from '../../../../templates/container';
import { getAttributes, ThemeUtils } from '../../../../../utils';
import { Image } from '../../../../atoms/image';
import { Text, TextSectionMarginBottomVariants, TextVariants } from '../../../../atoms/text';
import { IconButton, IconButtonRole, IconButtonSize, IconButtonStyles } from '../../../../atoms/icon-button';
var MuiServiceHighlights = styled(Container, {
    name: 'MuiServiceHighlights',
    overridesResolver: function (wrapperProps, styles) { return [styles.root]; }
})({});
var SH = function (_a) {
    var props = __rest(_a, []);
    var mainTitle = props.mainTitle, background = props.background, listItems = props.listItems;
    var wrapperConfig = {
        display: ContainerDisplays.Flex,
        flexDirection: ContainerFlexDirections.Column,
        flexGap: ContainerFlexGaps.Size_2
    };
    var listItemContainer = {
        display: ContainerDisplays.Flex,
        flexJustifyContent: ContainerFlexJustifyContents.SpaceBetween,
        flexAlignItems: ContainerFlexAlignItems.Center,
        padding: ThemeUtils.getResponsiveProp([
            {
                y: ContainerPaddings.Size_2,
                x: ContainerPaddings.Size_3
            }
        ]),
        background: background
    };
    var listInfoContainer = {
        display: ContainerDisplays.Flex,
        flexGap: ContainerFlexGaps.Size_3,
        flexAlignItems: ContainerFlexAlignItems.Center
    };
    return (React.createElement(MuiServiceHighlights, null,
        mainTitle && (React.createElement(Text.TextSection, { hasMarginBottom: TextSectionMarginBottomVariants.True },
            React.createElement(Text, { content: mainTitle, variant: TextVariants.Fs5 }))),
        React.createElement(Container, __assign({}, wrapperConfig), listItems === null || listItems === void 0 ? void 0 : listItems.map(function (listItemProps, idx) {
            var _a, _b, _c;
            var iconConfig = {
                icon: 'pmi-icon-info',
                size: IconButtonSize.Medium,
                style: IconButtonStyles.Empty,
                role: IconButtonRole.Button,
                'aria-label': listItemProps === null || listItemProps === void 0 ? void 0 : listItemProps.iconAreaLabel
            };
            return (React.createElement(Container, __assign({}, listItemContainer, getAttributes(listItemProps), { className: (listItemProps === null || listItemProps === void 0 ? void 0 : listItemProps.showInfoIcon) ? 'service-highlights-item' : '', key: "list-item-".concat(idx.toString()), onClick: function () {
                    var _a;
                    if (listItemProps === null || listItemProps === void 0 ? void 0 : listItemProps.showInfoIcon) {
                        (_a = listItemProps === null || listItemProps === void 0 ? void 0 : listItemProps.onClick) === null || _a === void 0 ? void 0 : _a.call(listItemProps);
                    }
                } }),
                React.createElement(Container, __assign({}, listInfoContainer),
                    ((_a = listItemProps === null || listItemProps === void 0 ? void 0 : listItemProps.image) === null || _a === void 0 ? void 0 : _a.src) && (React.createElement(Image, { src: (_b = listItemProps === null || listItemProps === void 0 ? void 0 : listItemProps.image) === null || _b === void 0 ? void 0 : _b.src, alt: ((_c = listItemProps === null || listItemProps === void 0 ? void 0 : listItemProps.image) === null || _c === void 0 ? void 0 : _c.alt) || '' })),
                    React.createElement(Text, { content: listItemProps === null || listItemProps === void 0 ? void 0 : listItemProps.content, variant: TextVariants.Body1, isHtml: true })),
                (listItemProps === null || listItemProps === void 0 ? void 0 : listItemProps.showInfoIcon) && React.createElement(IconButton, __assign({}, iconConfig))));
        }))));
};
export { SH as ServiceHighlights };
